// extracted by mini-css-extract-plugin
export var closeButton = "_o5-2";
export var closeButtonIcon = "_o5-3";
export var lightboxContent = "_o5-1";
export var lightboxOverlay = "_o5-0";